import { apiServiceConstants } from "../../constants";
import { ApiResponse } from "../../models";
import { apiService, utilService } from "../../services";
import { BehaviorSubject } from "rxjs";
import {
  NotificationsApiResponse,
  ScheduleChangeApiResponse,
} from "./NotificationsDataModels";

let notificationCount = new BehaviorSubject("");

const getNotifications =
  async (reqParams: {}): Promise<NotificationsApiResponse> => {
    return await apiService
      .apiCall(
        `notification/?reg_code=${utilService.getNetwork()}`,
        reqParams,
        apiServiceConstants.GET,
        utilService.getDeviceType()
      )
      .then((res) => {
        const response = res as NotificationsApiResponse;
        return response;
      })
      .catch((err) => {
        const error = err as NotificationsApiResponse;
        return error;
      });
  };

const updateReadStatus = async (reqParams: {
  sub_notification_guid: string;
}): Promise<ApiResponse> => {
  return await apiService
    .apiCall(
      `notification/${
        reqParams.sub_notification_guid
      }/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.PUT,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as ApiResponse;
      return response;
    })
    .catch((err) => {
      const error = err as ApiResponse;
      return error;
    });
};

const updateSchedules =
  async (reqParams: {}): Promise<ScheduleChangeApiResponse> => {
    return await apiService
      .apiCall(
        `shift/schedule-change-client-v2/?reg_code=${utilService.getNetwork()}`,
        reqParams,
        apiServiceConstants.POST,
        utilService.getDeviceType()
      )
      .then((res) => {
        const response = res as ScheduleChangeApiResponse;
        return response;
      })
      .catch((err) => {
        const error = err as ScheduleChangeApiResponse;
        return error;
      });
  };

const shiftRuleCheck = async (
  reqParams: any
): Promise<ScheduleChangeApiResponse> => {
  return await apiService
    .apiCall(
      `user/rule-check-client-v2/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as ScheduleChangeApiResponse;
      return response;
    })
    .catch((err) => {
      const error = err as ScheduleChangeApiResponse;
      return error;
    });
};

const unassignedAcceptDecline = async (reqParams: {}): Promise<ApiResponse> => {
  return await apiService
    .apiCall(
      `user/unassigned-notification-submit-v2/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as ApiResponse;
      return response;
    })
    .catch((err) => {
      const error = err as ApiResponse;
      return error;
    });
};

const updateNotificationSeenStatus =
  async (reqParams: {}): Promise<ApiResponse> => {
    return await apiService
      .apiCall(
        `user/unassigned-notification-seen/?reg_code=${utilService.getNetwork()}`,
        reqParams,
        apiServiceConstants.POST,
        utilService.getDeviceType()
      )
      .then((res) => {
        const response = res as ApiResponse;
        return response;
      })
      .catch((err) => {
        const error = err as ApiResponse;
        return error;
      });
  };

const getNotificationCount = async (reqParams: any): Promise<ApiResponse> => {
  return await apiService
    .apiCall(
      `notification/${reqParams.guid}/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as ApiResponse;
      return response;
    })
    .catch((err) => {
      const error = err as ApiResponse;
      return error;
    });
};
const unReadNotificationCount = (result: any) => {
  notificationCount.next(result);
};

const acceptAndSyncNotification = async (reqParams: {}): Promise<ApiResponse> => {
  return await apiService
    .apiCall(
      `user/autosync-update/?reg_code=${utilService.getNetwork()}`,
      reqParams,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const response = res as ApiResponse;
      return response;
    })
    .catch((err) => {
      const error = err as ApiResponse;
      return error;
    });
};

export const NotificationsService = {
  getNotifications,
  updateReadStatus,
  updateSchedules,
  unassignedAcceptDecline,
  updateNotificationSeenStatus,
  getNotificationCount,
  shiftRuleCheck,
  notificationCount,
  unReadNotificationCount,
  acceptAndSyncNotification
};
